import DepositSurvey from "../../../../modules/DepositSurvey/DepositSurvey";
import MobileSliderPagesWrapper from "../components/MobileSliderPagesWrapper";
import MobileSliderPagesHeader from "../components/MobileSliderPagesHeader";
import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { closeMobileSliderPageAction } from "../../../mobileAppActions";

function SlideMobileDepositSurvey() {
    const dispatch = useDispatch();

    const handleCloseSurvey = useCallback(() => {
        dispatch(closeMobileSliderPageAction())
    }, [dispatch]);

    return <MobileSliderPagesWrapper>
        <MobileSliderPagesHeader/>
        <DepositSurvey handleCloseSurvey={handleCloseSurvey}/>
    </MobileSliderPagesWrapper>
}

export default SlideMobileDepositSurvey;
